import { useCallback, useMemo } from "react";

import {
  LOCAL_STORAGE_LANGUAGE,
  STRIVACITY_BRAND_DOMAIN,
  STRIVACITY_CLIENT_ID,
  STRIVACITY_NONCE,
  STRIVACITY_REDIRECT,
  STRIVACITY_RESPONSE_TYPE,
  STRIVACITY_SCOPE,
  STRIVACITY_STATE,
} from "@utils/api-requests/static-data";
import { strivacityLanguage } from "@utils/lanugauge-settings/LanguageOptions";
import { useLocation } from "react-router-dom";

const sign = require("jwt-encode");

export const useRedirectToStrivacity = () => {
  const search = useLocation().search;

  const referralCode = useMemo(() => {
    const params = new URLSearchParams(search);

    return params.get("referral");
  }, [search]);

  const partenerCode = useMemo(() => {
    const params = new URLSearchParams(search);

    return params.get("partner");
  }, [search]);

  const siteLang = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);

  const loginHint = {
    language: {
      force: strivacityLanguage(siteLang),
    },
  };

  const joinLoginHint = useMemo(() => {
    if (partenerCode) {
      return {
        type: "registration",
        metadata: {
          attributes: {
            referralCode: partenerCode,
            referralType: "1",
          },
        },
        language: { force: strivacityLanguage(siteLang) },
      };
    }

    if (referralCode) {
      return {
        type: "registration",
        metadata: {
          attributes: {
            referralCode: referralCode,
            referralType: "2",
          },
        },
        language: { force: strivacityLanguage(siteLang) },
      };
    } else {
      return {
        type: "registration",
        metadata: {
          attributes: {
            referralCode: "",
            referralType: "3",
          },
        },
        language: { force: strivacityLanguage(siteLang) },
      };
    }
  }, [referralCode, partenerCode, siteLang]);

  const encodedLoginHint =
    sign(loginHint, "").split(".").slice(0, 2).join(".") + ".";

  const joinEncodedLoginHint =
    sign(joinLoginHint, "").split(".").slice(0, 2).join(".") + ".";

  const STRIVACITY_SIGNIN_REDIRECT_URI =
    `${STRIVACITY_BRAND_DOMAIN}/oauth2/auth` +
    `?client_id=${STRIVACITY_CLIENT_ID}` +
    `&redirect_uri=${STRIVACITY_REDIRECT}` +
    `&response_type=${STRIVACITY_RESPONSE_TYPE}` +
    `&scope=${STRIVACITY_SCOPE}` +
    `&nonce=${STRIVACITY_NONCE}` +
    `&state=${STRIVACITY_STATE}` +
    `&login_hint=${encodedLoginHint}`;

  const STRIVACITY_JOIN_REDIRECT_URI =
    `${STRIVACITY_BRAND_DOMAIN}/oauth2/auth?` +
    `client_id=${STRIVACITY_CLIENT_ID}` +
    `&redirect_uri=${STRIVACITY_REDIRECT}` +
    `&response_type=${STRIVACITY_RESPONSE_TYPE}` +
    `&scope=${STRIVACITY_SCOPE}` +
    `&nonce=${STRIVACITY_NONCE}` +
    `&state=${STRIVACITY_STATE}` +
    `&prompt=create` +
    `&login_hint=${joinEncodedLoginHint}`;

  const redirectToLoginPage = useCallback(() => {
    window.location.href = STRIVACITY_SIGNIN_REDIRECT_URI;
  }, [STRIVACITY_SIGNIN_REDIRECT_URI]);

  const redirectToSignUpPage = useCallback(() => {
    window.location.href = STRIVACITY_JOIN_REDIRECT_URI;
  }, [STRIVACITY_JOIN_REDIRECT_URI]);

  return {
    redirectToLoginPage,
    redirectToSignUpPage,
  };
};
